__turbopack_context__.v({
  "content": "ProductReviews-module-scss-module__gvuBGq__content",
  "emptyState": "ProductReviews-module-scss-module__gvuBGq__emptyState",
  "layout": "ProductReviews-module-scss-module__gvuBGq__layout",
  "review-focus-highlight": "ProductReviews-module-scss-module__gvuBGq__review-focus-highlight",
  "reviewFocused": "ProductReviews-module-scss-module__gvuBGq__reviewFocused",
  "reviewList": "ProductReviews-module-scss-module__gvuBGq__reviewList",
  "root": "ProductReviews-module-scss-module__gvuBGq__root",
  "showMoreButton": "ProductReviews-module-scss-module__gvuBGq__showMoreButton",
  "titleRow": "ProductReviews-module-scss-module__gvuBGq__titleRow",
  "variantActive": "ProductReviews-module-scss-module__gvuBGq__variantActive",
  "variantSwitch": "ProductReviews-module-scss-module__gvuBGq__variantSwitch",
  "withoutMedia": "ProductReviews-module-scss-module__gvuBGq__withoutMedia",
});
